import IBaseModel from "../base/base-model";
import { ILocation } from "../store/response";

// Simple location for location change feature
export interface ISimpleLocation {
  lat: number;
  lng: number;
}

// Browsing store for location change feature
export interface IBrowsingStore {
  id: number;
  name: string;
}

// Trip status enum for order protection
export enum TripStatus {
  PENDING = 1,
  ACTIVE = 2,
  COMPLETED = 3,
  CANCELLED = 4,
}

// Delivery mode enum
export enum OrderDeliveryMode {
  LEGACY = 1,
  TRIP_BASED = 2,
}

export interface IOrderShort {
  id: number;
  status: number;
  createdAt: string;
  store: any;
  // Trip information fields
  tripId?: number | null;
  tripNumber?: string | null;
  tripStatus?: TripStatus | null;
  // Delivery mode
  deliveryMode?: OrderDeliveryMode;
  // Location change fields
  locationChanged?: boolean;
  currentLocation?: ISimpleLocation | null;
  browsingStore?: IBrowsingStore | null;
  deliveryStore?: IBrowsingStore | null;
  browsingTotalPrice?: number | null;
  deliveryTotalPrice?: number | null;
  priceDifference?: number | null;
}

export interface IOrder {
  id: number;
  client: Client;
  driver: any;
  type: number;
  store: any;
  investor: any;
  status: number;
  finalPrice: number;
  isEmergency: boolean;
  isRecipe: boolean;
  isExpressDelivery: boolean;
  client_note: any;
  note: string;
  createdAt: string;
  orderSchedulingType: number;
  paymentReceivedBy?: User;
  paymentReceivedAt?: string;
  location?: ILocation;
  // Trip information fields
  tripId?: number | null;
  tripNumber?: string | null;
  tripStatus?: TripStatus | null;
  // Delivery mode
  deliveryMode?: OrderDeliveryMode;
  // Location change fields
  locationChanged?: boolean;
  currentLocation?: ISimpleLocation | null;
  browsingStore?: IBrowsingStore | null;
  deliveryStore?: IBrowsingStore | null;
  browsingTotalPrice?: number | null;
  deliveryTotalPrice?: number | null;
  priceDifference?: number | null;
}

export interface IRatedOrder {
  id: number;
  client: Client;
  type: number;
  status: number;
  finalPrice: number;
  totalPriceOnClient: number;
  rating: any;
  clientRateNote: string;
  createdAt: string;
  finishDatetime: string;
  // Trip information fields
  tripId?: number | null;
  tripNumber?: string | null;
  tripStatus?: TripStatus | null;
  // Delivery mode
  deliveryMode?: OrderDeliveryMode;
  // Location change fields
  locationChanged?: boolean;
  currentLocation?: ISimpleLocation | null;
  browsingStore?: IBrowsingStore | null;
  deliveryStore?: IBrowsingStore | null;
  browsingTotalPrice?: number | null;
  deliveryTotalPrice?: number | null;
  priceDifference?: number | null;
}

export interface IOrderDetails extends IBaseModel {
  id: number;
  number: string;
  client: Client;
  driver: any;
  type: number;
  store: any;
  investor: any;
  status: number;
  finalPrice: number;
  isEmergency: boolean;
  orderBroadcastArea: boolean;
  orderBroadcastCity: boolean;
  productBroadcastArea: boolean;
  productBroadcastCity: boolean;
  isRecipe: boolean;
  StoreHaveRecipe: any;
  recipes: any[];
  recipeAsText: any;
  notes: any[];
  clientNote: any;
  distance: any;
  totalPrice: number;
  totalPriceOnClient: number;
  productYield: number;
  priceDeliveryService: number;
  priceDeliveryServiceOnClient: number;
  priceDeliveryYield: number;
  discountCode: any;
  discountCodeValueForDelivery: number;
  discountCodeValueForProduct: number;
  rating: any;
  contact: boolean;
  ringingBell: boolean;
  clientNoteDelivery: any;
  note: string;
  orderProducts: any[];
  selectedStore: boolean;
  reasonCancel: any;
  clientRateNote: string;
  finishDatetime: Date;
  startDatetimeDriver: Date;
  clientAddress: string;
  orderSchedulingType: number;
  scheduleTime: Date;
  location: ILocation
  isExpressDelivery: boolean;
  quantityProcessed: boolean;
  paymentReceivedBy?: User;
  paymentReceivedAt?: string;
  // Trip protection fields
  tripId?: number | null;
  tripNumber?: string | null;
  tripStatus?: TripStatus | null;
  // Delivery mode
  deliveryMode?: OrderDeliveryMode;
  // Location change fields
  locationChanged?: boolean;
  currentLocation?: ISimpleLocation | null;
  browsingStore?: IBrowsingStore | null;
  deliveryStore?: IBrowsingStore | null;
  browsingTotalPrice?: number | null;
  deliveryTotalPrice?: number | null;
  priceDifference?: number | null;
}

export interface Client {
  id: number;
  firstName: string;
  lastName: string;
  mobile: string;
  cleanMobile?: string;
  acceptedOrdersCount?: number
  lastCompletedOrderDate?: string
}

export interface User {
  id: number;
  firstName: string;
  lastName: string;
  fullName?: string;
}
